module.exports = __webpack_public_path__ + "img/door.0b1e9bcd.svg";